import { render, staticRenderFns } from "./AddModelManagment.vue?vue&type=template&id=3d42e26c&scoped=true"
import script from "./AddModelManagment.vue?vue&type=script&lang=js"
export * from "./AddModelManagment.vue?vue&type=script&lang=js"
import style0 from "./AddModelManagment.vue?vue&type=style&index=0&id=3d42e26c&prod&lang=less&scoped=true"
import style1 from "./AddModelManagment.vue?vue&type=style&index=1&id=3d42e26c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d42e26c",
  null
  
)

export default component.exports